import { createSelector } from '@reduxjs/toolkit';
import { createStructuredSelector } from 'reselect';
import { isAutoPaymentEnabled } from '../../billing/billing-utils';
import { billedSimState, foreignSimState } from 'console/sim/utils/state';
import { selectSimFromDevice } from 'console/sim/utils/select-sim';
import { createSubsetSelector } from 'webui/utils/selectors';
import { selectDevice } from 'entities/device/lib';
export const billedSimsHaveProblems = (state) => billedSimsWithProblems(state).length > 0;
export const billedSimsWithProblems = (state) => {
    const autopayment = isAutoPaymentEnabled(state);
    const account_balance = state.billing.state.data.balance_x100;
    const sim_prices = new Map((state.billing.prices?.sim_tariffs ?? []).map(({ id, month_price_x100 }) => [
        id,
        month_price_x100,
    ]));
    return state.account.sims.filter((sim) => billedSimState(sim, autopayment, account_balance, sim_prices.get(sim.tariff_state.current)).status != 'ok');
};
const dataForCheckBilledSimProblem = createStructuredSelector({
    is_auto_payment: isAutoPaymentEnabled,
    balance_x100: (state) => state.billing.state.data.balance_x100,
    sim_tariffs: (state) => new Map((state.billing.prices.sim_tariffs ?? []).map(({ id, month_price_x100 }) => [
        id,
        month_price_x100,
    ])),
});
export const simHaveProblem = createSelector(selectSimFromDevice, dataForCheckBilledSimProblem, (sims_in_device, { is_auto_payment, balance_x100, sim_tariffs }) => {
    const [billed_sim] = sims_in_device;
    if (!billed_sim) {
        return '';
    }
    const { status, text } = billedSimState(billed_sim, is_auto_payment, balance_x100, sim_tariffs.get(billed_sim.tariff_state.current));
    return status != 'ok' ? billed_sim.sim_card.msisdn + ' ' + text : '';
});
const deviceWithBalance = createSelector((state, device_id) => selectDevice(state, device_id), createSubsetSelector(['balance_value', 'balance', 'z3k_config']));
export const simProblemStatus = createSelector(selectSimFromDevice, dataForCheckBilledSimProblem, deviceWithBalance, (sims_in_device, { is_auto_payment, balance_x100, sim_tariffs }, device) => {
    const [billed_sim, foreign_sim] = sims_in_device;
    if (billed_sim) {
        return billedSimState(billed_sim, is_auto_payment, balance_x100, sim_tariffs.get(billed_sim.tariff_state.current));
    }
    if (foreign_sim && device) {
        return foreignSimState(device.balance, device.balance_value, device.z3k_config);
    }
    return { status: 'ok', text: '' };
});
export const simProblemStatusState = createSelector(simProblemStatus, (status) => status.status);
export const simProblemStatusText = createSelector(simProblemStatus, (status) => status.text);
